import { render, staticRenderFns } from "./FileUploader.vue?vue&type=template&id=63c5897e&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"
import style0 from "./FileUploader.vue?vue&type=style&index=0&id=63c5897e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c5897e",
  null
  
)

export default component.exports